import React from 'react';
import dayjs from 'dayjs';
import styles from './style.module.scss';

const year = dayjs().format('YYYY');

const Footer = () => (
  <footer className={styles.footer}>
    <div>
      {year} © Dashboard Story, Inc. All rights reserved. <span className="hide-phone">www.duetinc.com</span>
      <div>{process.env.REACT_APP_Ver}</div>
    </div>
  </footer>
);

export default Footer;
